import { Grid } from '@mui/material'
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { Control, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES, VALIDATIONS } from '../../../../Constants'
import { combineErrorMessage } from '../../../../Helpers/Util'
import { CountriesListResponse } from '../../../../Models'
import { useAppDispatch, useAppSelector } from '../../../../Store/Hooks'
import { showAlert } from '../../../../Store/Slice/alert.slice'
import { MUIBox, MUIButton, MUIField } from '../../../Shared'
import MUIAutocompleteSingleSelect from '../../../Shared/MUI-AutocompleteSingleSelect'
import styles from '../Masters.module.scss'
import {
  createCountryService,
  editCountryService,
  selectCountryData,
  setCountriesData,
} from '../../../../Store/Slice/countries.slice'

interface CountriesCreateEditFormPropsInterface {
  mastersPageType: string | undefined
}
const COUNTRY_CONTENTS = 'Country'
const status: any = [
  { value: 'ACTIVE', label: 'Active', type: 'status-active' },
  { value: 'INACTIVE', label: 'In Active', type: 'status-inactive' },
]

const CountriesCreateEdit = ({ mastersPageType }: CountriesCreateEditFormPropsInterface) => {
  const selectCountry = useAppSelector(selectCountryData)
  const selectedCountryData: CountriesListResponse | null =
    mastersPageType === CONSTANTS.PAGE_TYPE.CREATE ? null : selectCountry
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm<any>({
    defaultValues: {
      id: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?._id : '',
      status: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.status : 'ACTIVE',
      value: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.value : '',
      key: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.key : '',
    },
  })

  useEffect(() => {
    // Update form values when selectedCountryData changes
    setValue('id', mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?._id : '')
    setValue(
      'status',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.status : 'ACTIVE',
    )
    setValue(
      'value',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.value : '',
    )
    setValue('key', mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedCountryData?.key : '')
  }, [selectedCountryData, mastersPageType, setValue])

  const createCountry = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(createCountryService(reqData) as any)
    return result
  }

  const editCountry = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(editCountryService(reqData) as any)
    return result
  }

  const onSubmit = async (data: any) => {
    let result: any
    if (selectedCountryData?._id && mastersPageType === CONSTANTS.PAGE_TYPE.EDIT) {
      result = await editCountry(data)
    }
    if (mastersPageType === CONSTANTS.PAGE_TYPE.CREATE) {
      if (Object.hasOwn(data, 'id')) {
        delete data?.id
      }
      result = await createCountry(data)
    }
    const unWrapRes = unwrapResult(result)
    if (unWrapRes?.error) {
      dispatch(showAlert([true, combineErrorMessage(unWrapRes), 'error']))
      return
    }
    dispatch(showAlert([true, unWrapRes.message, 'success']))
    dispatch(setCountriesData(null))
    navigate(`/${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.Masters}/${PAGES_ROUTES.Countries}`)
  }

  return (
    <MUIBox>
      <div>
        <div className={`heading-6 d-flex text-left ${styles.masters__box__header__padding}`}>
          {COUNTRY_CONTENTS}
        </div>
        <div className={styles.hr}></div>
        <div className={styles.mastersbox__content_padding}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container columnSpacing={10} rowSpacing={4}>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='key'
                  label='Key'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='value'
                  label='Value'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIAutocompleteSingleSelect
                  name='status'
                  label={'Status'}
                  required
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  options={status}
                  onChange={(e: any) => setValue?.('status', e.target.value)}
                />
              </Grid>
              <Grid xs={12} item>
                <Grid container spacing={10}>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6} className='d-flex justify-content-end'>
                    <MUIButton
                      disabled={!isValid}
                      size='large'
                      type={'submit'}
                      label={'Submit'}
                      variant='contained'
                      width={200}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </MUIBox>
  )
}

export default React.memo(CountriesCreateEdit)
